









import { Component, Prop, Vue } from "vue-property-decorator";
import Chart from "@/components/app/global/stats/charts/chart/index.vue";
import {
  calcGroup,
  dateFormat,
  convertToDate,
  dateRangeValues,
  currencyColor
} from "@/components/app/global/stats/charts/utils";
import { STATS_DEFAULT_CURRENCY_CODE } from "@/data/constants";

@Component({
  components: {
    chart: Chart
  }
})
export default class DateRangeChart extends Vue {
  @Prop({ required: true })
  public dateFrom!: Date;

  @Prop({ required: true })
  public dateTo!: Date;

  @Prop({ default: STATS_DEFAULT_CURRENCY_CODE })
  public currencyCode!: string;

  @Prop({ default: null })
  public valueFunc!: (payload) => any;

  public get dates() {
    return [this.dateFrom, this.dateTo];
  }

  public get params() {
    // If no dates are provide show all until now
    if (this.$_.isEmpty(this.dates)) {
      return {
        group: calcGroup(this.dates),
        ...(this.$attrs.params as any),
        date_to: this.$moment().format("YYYY-MM-DD")
      };
    }

    // Show in range
    return {
      group: calcGroup(this.dates),
      ...(this.$attrs.params as any),
      date_from: this.$moment(this.dateFrom).format("YYYY-MM-DD"),
      date_to: this.$moment(this.dateTo).format("YYYY-MM-DD")
    };
  }

  public executeChartDataFunc(payload) {
    return this.valueFunc
      ? this.valueFunc({ ...payload, dates: this.dates })
      : this.getChartData(payload);
  }

  public getChartData({ data, currencyCode, currency }) {
    const result: any[] = [];
    const statData = data || { [currencyCode]: [] };
    [currencyCode].map((currencyCodeData, index) => {
      const dates = this.$_.get(statData, currencyCodeData, []).map(i =>
        this.$moment(convertToDate(i.year, i.day, i.hour))
      );

      const format = dateFormat(this.params.group, this.dates);

      const mappedData = dateRangeValues(
        this.params.group,
        this.dates,
        dates,
        (statData[currencyCodeData] || []).map(i => i.count || 0)
      );

      const color = currencyColor({ index, currencyCodeData });

      result.push({
        labels: mappedData.map(i => i.date.format(format)),
        dataset: {
          label:
            currency && currencyCodeData !== currency.code
              ? `${currencyCodeData} (${currency.code})`
              : currencyCodeData,
          borderColor: color.borderColor,
          backgroundColor: color.backgroundColor,
          data: mappedData.map(i => i.value)
        }
      });
    });
    return {
      labels: result[0].labels,
      datasets: result.map(i => i.dataset)
    };
  }
}
